import React, { useState, useEffect, useRef  } from 'react';
import { 
  Settings, Boxes,
  Database, File,
  HardDrive, XCircle,
  Clock, Network,
  Cloud,ArrowLeftCircle, User,
  Bell, AlertTriangle, CheckCircle, Info,
  Menu, ExternalLink, MoreHorizontal, Search,
  Home, RefreshCw, Download,
  History, ChevronDown, ChevronUp, CheckCircle2,
  Settings2,
  HelpCircle,
  AlertCircle,
  X, ChevronRight,
  Check ,
  Save,
  Server,
  Calendar,
  Lock,
  Filter,
  Folder,  
  Plus,
  Trash2,
  FileText,
  Shield,
  ToggleLeft,
  Archive
} from 'lucide-react';
import BackupMonitoring from './Backmonitoring'; // Adjust the import based on your folder structure

// Custom Card Component
const Card = ({ children, className = '' }) => (
  <div className={`bg-gray-800 rounded-lg shadow-lg overflow-hidden ${className}`}>
    {children}
  </div>
);

const CardHeader = ({ children }) => (
  <div className="p-4 border-b border-gray-700">
    {children}
  </div>
);

const CardTitle = ({ children }) => (
  <h3 className="text-lg font-semibold flex items-center">
    {children}
  </h3>
);

const CardContent = ({ children }) => (
  <div className="p-4">
    {children}
  </div>
);

// Custom Alert Component
const Alert = ({ children, type = 'error' }) => {
  const bgColor = type === 'error' ? 'bg-red-900/50' : 'bg-yellow-900/50';
  return (
    <div className={`${bgColor} border border-red-800 rounded-lg p-4 mt-4`}>
      {children}
    </div>
  );
};

const Checkbox = ({ label, ...props }) => (
  <label className="flex items-center space-x-2 cursor-pointer">
    <input
      type="checkbox"
      {...props}
      className="form-checkbox rounded bg-gray-700 border-gray-600 text-blue-500 focus:ring-blue-500"
    />
    <span className="text-gray-300">{label}</span>
  </label>
);

// Custom Input Component
  const Input = ({ type = 'text', value, onChange, placeholder, className = '' }) => (
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`w-full bg-gray-700 rounded p-2 border border-gray-600 focus:border-blue-500 focus:outline-none ${className}`}
    />
  );

  const BackupAnimationSystem = ({ isBackupPopupOpen, setIsBackupPopupOpen })  => {   
    const [animatingFiles, setAnimatingFiles] = useState([]);
    const [activeNodes, setActiveNodes] = useState([]);
    const [transferStats, setTransferStats] = useState({
      filesProcessed: 0,
      dataTransferred: 0,
      currentSpeed: 0
    });
  
    // Unique prefix for all IDs and classes
    const uniquePrefix = 'enterprise_backup_';


  
    const generateFile = () => ({
      id: `${uniquePrefix}${Math.random().toString(36).substr(2, 9)}`,
      type: Math.random() > 0.7 ? 'folder' : 'file',
      name: ['Document', 'Project', 'Database', 'Config', 'Archive'][Math.floor(Math.random() * 5)],
      size: Math.floor(Math.random() * 1000),
      path: `/root/${Math.random().toString(36).substr(2, 6)}`,
      priority: Math.random() > 0.8 ? 'high' : 'normal'
    });
  
    const generateNode = () => ({
      id: `${uniquePrefix}node_${Math.random().toString(36).substr(2, 9)}`,
      type: ['server', 'database', 'storage'][Math.floor(Math.random() * 3)],
      status: 'active',
      position: {
        x: Math.random() * 80 + 10,
        y: Math.random() * 80 + 10
      }
    });
  
    useEffect(() => {
      if (isBackupPopupOpen) {
        // Generate initial nodes
        setActiveNodes(Array(5).fill(null).map(generateNode));
        
        // File generation interval
        const fileInterval = setInterval(() => {
          if (Math.random() > 0.4) {
            setAnimatingFiles(prev => [...prev.slice(-15), generateFile()]);
            setTransferStats(prev => ({
              filesProcessed: prev.filesProcessed + 1,
              dataTransferred: prev.dataTransferred + Math.floor(Math.random() * 50),
              currentSpeed: Math.floor(Math.random() * 100) + 50
            }));
          }
        }, 200);
  
        // Node status update interval
        const nodeInterval = setInterval(() => {
          setActiveNodes(prev => prev.map(node => ({
            ...node,
            status: Math.random() > 0.9 ? 'processing' : 'active'
          })));
        }, 1000);
  
        return () => {
          clearInterval(fileInterval);
          clearInterval(nodeInterval);
        };
      }
    }, [isBackupPopupOpen]);
  
    const formatBytes = (bytes) => {
      if (bytes < 1024) return `${bytes} B`;
      if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
      return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    };
  
    return (
      <div className="flex flex-col items-center gap-4">
          
        {isBackupPopupOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center p-4">
            <div className="bg-gray-900 rounded-xl p-6 w-full max-w-4xl relative border border-gray-700">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Left Panel - Transfer Visualization */}
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold text-gray-100 flex items-center gap-2">
                    <Server className="text-blue-400" size={20} />
                    System Backup Monitor
                  </h3>
  
                  <div className="relative h-64 border border-gray-700 rounded-lg bg-gray-800/50 overflow-hidden">
                    {/* Network Nodes */}
                    {activeNodes.map(node => (
                      <div
                        key={node.id}
                        className={`absolute w-3 h-3 rounded-full ${
                          node.status === 'processing' ? 'bg-green-400' : 'bg-blue-400'
                        } animate-pulse`}
                        style={{
                          left: `${node.position.x}%`,
                          top: `${node.position.y}%`
                        }}
                      >
                        <div className="absolute -inset-1 bg-current opacity-20 rounded-full animate-ping" />
                      </div>
                    ))}
  
                    {/* Animated Files */}
                    {animatingFiles.map(file => (
                      <div
                        key={file.id}
                        className={`absolute animate-file-transfer`}
                        style={{
                          top: `${Math.random() * 80 + 10}%`,
                          '--random-y': `${Math.random() * 40 - 20}px`
                        }}
                      >
                        <div className="flex items-center gap-1 bg-gray-800 px-2 py-1 rounded-md border border-gray-700">
                          {file.type === 'folder' ? (
                            <Folder size={12} className="text-yellow-400" />
                          ) : (
                            <File size={12} className="text-blue-400" />
                          )}
                          <span className="text-xs text-gray-300">{file.name}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
  
                {/* Right Panel - Statistics */}
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div className="bg-gray-800 p-4 rounded-lg border border-gray-700">
                      <div className="flex items-center gap-2 text-gray-400 mb-2">
                        <Boxes size={16} />
                        <span className="text-sm">Files Processed</span>
                      </div>
                      <div className="text-2xl font-mono text-gray-100">
                        {transferStats.filesProcessed.toLocaleString()}
                      </div>
                    </div>
  
                    <div className="bg-gray-800 p-4 rounded-lg border border-gray-700">
                      <div className="flex items-center gap-2 text-gray-400 mb-2">
                        <Database size={16} />
                        <span className="text-sm">Data Transferred</span>
                      </div>
                      <div className="text-2xl font-mono text-gray-100">
                        {formatBytes(transferStats.dataTransferred)}
                      </div>
                    </div>
                  </div>
  
                  <div className="bg-gray-800 p-4 rounded-lg border border-gray-700">
                    <div className="flex items-center gap-2 text-gray-400 mb-2">
                      <Network size={16} />
                      <span className="text-sm">Transfer Speed</span>
                    </div>
                    <div className="text-xl font-mono text-gray-100">
                      {transferStats.currentSpeed} MB/s
                    </div>
                    <div className="mt-2 h-1 bg-gray-700 rounded-full overflow-hidden">
                      <div 
                        className="h-full bg-blue-500 transition-all duration-500"
                        style={{ width: `${Math.min(transferStats.currentSpeed, 100)}%` }}
                      />
                    </div>
                  </div>
  
                  <div className="flex gap-2 text-xs text-gray-500">
                    <Shield size={14} className="text-green-400" />
                    <span>Secure Transfer Protocol Active</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
       
         {/* Use a regular style tag instead */}
      <style>
        {`
          @keyframes fileTransfer {
            0% {
              transform: translateX(0) translateY(0);
              opacity: 0;
            }
            20% {
              transform: translateX(100px) translateY(var(--random-y));
              opacity: 1;
            }
            80% {
              transform: translateX(${window.innerWidth < 768 ? '200px' : '400px'}) translateY(calc(var(--random-y) * -1));
              opacity: 1;
            }
            100% {
              transform: translateX(${window.innerWidth < 768 ? '300px' : '500px'}) translateY(0);
              opacity: 0;
            }
          }
          
          .animate-file-transfer {
            animation: fileTransfer 2s cubic-bezier(0.4, 0, 0.2, 1) forwards;
          }
        `}
      </style>
      </div>
    );
  };

  
  
  const EnhancedModal = ({ 
    isOpen, 
    title, 
    variant = 'error',
    message,
    validationErrors = {},
    showCloseButton = true,
    onModalClose,
    onAction,
    actionLabel
  }) => {
    const [isAnimatingIn, setIsAnimatingIn] = useState(false);
    const [isAnimatingOut, setIsAnimatingOut] = useState(false);
  
    useEffect(() => {
      if (isOpen) {
        setIsAnimatingIn(true);
        setIsAnimatingOut(false);
      }
    }, [isOpen]);
  
    const handleClose = () => {
      onModalClose(false); // Call the function with the new value
    };
  
    
    if (!isOpen && !isAnimatingOut) return null;
  
    const variantStyles = {
      error: {
        icon: AlertCircle,
        iconColor: 'text-red-400',
        borderGlow: 'shadow-[0_0_15px_rgba(239,68,68,0.2)]',
        accentColor: 'bg-red-500/10',
        borderAccent: 'border-red-500/20',
        textAccent: 'text-red-400'
      },
      warning: {
        icon: AlertTriangle,
        iconColor: 'text-yellow-400',
        borderGlow: 'shadow-[0_0_15px_rgba(234,179,8,0.2)]',
        accentColor: 'bg-yellow-500/10',
        borderAccent: 'border-yellow-500/20',
        textAccent: 'text-yellow-400'
      },
      success: {
        icon: CheckCircle,
        iconColor: 'text-emerald-400',
        borderGlow: 'shadow-[0_0_15px_rgba(16,185,129,0.2)]',
        accentColor: 'bg-emerald-500/10',
        borderAccent: 'border-emerald-500/20',
        textAccent: 'text-emerald-400'
      },
      info: {
        icon: Info,
        iconColor: 'text-blue-400',
        borderGlow: 'shadow-[0_0_15px_rgba(59,130,246,0.2)]',
        accentColor: 'bg-blue-500/10',
        borderAccent: 'border-blue-500/20',
        textAccent: 'text-blue-400'
      }
    };
  
    const styles = variantStyles[variant];
    const IconComponent = styles.icon;
  
    return (
      <div className={`fixed inset-0 z-50 flex items-center overflow-y-auto justify-center p-4 ${
        isAnimatingIn ? 'animate-modal-backdrop-in' : 
        isAnimatingOut ? 'animate-modal-backdrop-out' : ''
      }`}>
        {/* Backdrop with blur effect */}
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm" onClick={handleClose} />
    
        {/* Modal Container */}
        <div className={`relative w-full max-w-lg transform ${
          isAnimatingIn ? 'animate-modal-in' : 
          isAnimatingOut ? 'animate-modal-out' : ''
        }`}>
          {/* Glowing border effect */}
          <div className={`absolute inset-0 rounded-2xl ${styles.borderGlow} transition-opacity duration-500`} />
    
          {/* Main modal content */}
          <div className={`relative rounded-xl bg-gray-900 border ${styles.borderAccent} overflow-hidden max-h-[80vh]`}>
            {/* This will set a max height for the modal content */}
            {/* Animated gradient background */}
            <div className="absolute inset-0 bg-gradient-to-br from-gray-800 to-gray-900" />
            
            {/* Header section */}
            <div className="relative p-6 overflow-y-auto max-h-[80vh]">
              <div className="flex items-start gap-4">
                <div className={`flex-shrink-0 p-2 rounded-lg ${styles.accentColor}`}>
                  <IconComponent className={`h-6 w-6 ${styles.iconColor}`} />
                </div>
                
                <div className="flex-1 min-w-0">
                  <h3 className={`text-lg font-medium ${styles.textAccent} mb-2`}>
                    {title}
                  </h3>
                  {message && (
                    <p className="text-gray-300 text-sm leading-relaxed">
                      {message}
                    </p>
                  )}
                </div>
    
                {showCloseButton && (
                  <button
                    onClick={handleClose}
                    className="text-gray-400 hover:text-gray-300 transition-colors"
                  >
                    <X className="h-5 w-5" />
                  </button>
                )}
              </div>
    
              {/* Validation Errors - Ensure it also scrolls if there are many errors */}
              {Object.keys(validationErrors).length > 0 && (
                <div className="mt-4 space-y-3 max-h-[60vh] overflow-y-auto">
                  {Object.entries(validationErrors).map(([key, error], index) => (
                    <div 
                      key={key}
                      className={`flex items-start gap-3 p-3 rounded-lg ${styles.accentColor} animate-error-entry`}
                      style={{ 
                        animationDelay: `${index * 100}ms`,
                        animationFillMode: 'both' 
                      }}
                    >
                      <AlertCircle className={`h-5 w-5 ${styles.iconColor}`} />
                      <div className="flex-1 min-w-0">
                        <p className="text-sm text-gray-300">{error}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
    
              {/* Security indicator */}
              <div className="mt-6 flex items-center gap-2 text-gray-400 text-sm">
                <Shield className="h-4 w-4" />
                <span>End-to-end encrypted</span>
              </div>
            </div>
    
            {/* Actions section */}
            <div className="relative px-6 py-4 bg-gray-800/50 flex flex-col sm:flex-row-reverse gap-2">
              {onAction && (
                <button
                  onClick={onAction}
                  className={`inline-flex items-center justify-center px-4 py-2 rounded-lg font-medium text-white ${styles.accentColor} hover:bg-opacity-80 transition-colors`}
                >
                  {actionLabel || 'Confirm'}
                  <ExternalLink className="ml-2 h-4 w-4" />
                </button>
              )}
              <button
                onClick={handleClose}
                className="inline-flex items-center justify-center px-4 py-2 rounded-lg font-medium text-gray-300 hover:bg-gray-700 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>  
        
        <style>
          {`
            @keyframes modalBackdropIn {
              from { opacity: 0; }
              to { opacity: 1; }
            }
    
            @keyframes modalBackdropOut {
              from { opacity: 1; }
              to { opacity: 0; }
            }
    
            @keyframes modalIn {
              from {
                opacity: 0;
                transform: scale(0.95) translateY(-10px);
              }
              to {
                opacity: 1;
                transform: scale(1) translateY(0);
              }
            }
    
            @keyframes modalOut {
              from {
                opacity: 1;
                transform: scale(1) translateY(0);
              }
              to {
                opacity: 0;
                transform: scale(0.95) translateY(10px);
              }
            }
    
            @keyframes errorEntry {
              from {
                opacity: 0;
                transform: translateX(-10px);
              }
              to {
                opacity: 1;
                transform: translateX(0);
              }
            }
    
            .animate-modal-backdrop-in {
              animation: modalBackdropIn 0.2s ease-out forwards;
            }
    
            .animate-modal-backdrop-out {
              animation: modalBackdropOut 0.2s ease-in forwards;
            }
    
            .animate-modal-in {
              animation: modalIn 0.3s cubic-bezier(0.21, 1.02, 0.73, 1) forwards;
            }
    
            .animate-modal-out {
              animation: modalOut 0.2s ease-in forwards;
            }
    
            .animate-error-entry {
              animation: errorEntry 0.3s cubic-bezier(0.21, 1.02, 0.73, 1) forwards;
            }
          `}
        </style>   
      </div>
    );
  };
  


const DestinationConfiguration = ({
  destLocalStorageOptions,
  destStorageTypes,
  destStorage,
  setDestStorage,
  destDiskMessage,
  destFolderContents,
  destSelectedItems,
  handleDestDiskClick,
  handleDestStorageSelect,
  handleDestItemClick,
  destProvider,
  destFormData,
  setDestFormData,
  handleDestInputChange,
  destFieldErrors,
  handleDestApply,
  setDestProvider,
  setDestSelectedItems,
  setDestDiskMessage,
}) => {
  return (
    <div className="p-6">
      {!destStorage ? (
        <div className="space-y-4">
          {/* Local Storage Box */}
          {destLocalStorageOptions.length > 0 && (
            <div className="bg-gray-900 p-4 rounded-lg border border-gray-700 overflow-y-auto max-h-60">
              <div className="font-medium capitalize text-gray-300">Local Storage</div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {destLocalStorageOptions.map((option) => (
                  <button
                    key={`${option.fdloc}`}
                    onClick={() => {
                      setDestStorage(option);
                      handleDestDiskClick(option, false); // Pass isSource as false
                    }}
                    className={`flex items-center p-4 border border-gray-700 hover:border-blue-500 hover:bg-blue-800 transition-all rounded-lg ${
                      destStorage === option ? 'bg-blue-600' : ''
                    }`}
                  >
                    <HardDrive className="w-5 h-5 mr-3 text-gray-300" />
                    <span className="flex-1 text-left text-gray-300">{option.name}</span>
                    <ChevronRight className="w-4 h-4 text-gray-400" />
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Other Storage Options */}
          {destStorageTypes.map((storage) => (
            <div key={storage.type} className="bg-gray-900 p-4 rounded-lg border border-gray-700 overflow-y-auto max-h-60">
              <div className="font-medium capitalize text-gray-300">{`${storage.type} Storage`}</div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {storage.options.map((option) => (
                  <button
                    key={option.id}
                    onClick={() => {
                      setDestStorage(option);
                      handleDestStorageSelect(storage.type, option);
                      //handleDestDiskClick(option, false); // Pass isSource as false
                    }}
                    className="flex items-center p-4 border border-gray-700 hover:border-blue-500 hover:bg-blue-800 transition-all rounded-lg"
                  >
                    {storage.type === 'cloud' && <Cloud className="w-5 h-5 mr-3 text-gray-300" />}
                    {storage.type === 'nas' && <Server className="w-5 h-5 mr-3 text-gray-300" />}
                    <span className="flex-1 text-left text-gray-300">{option.name}</span>
                    <ChevronRight className="w-4 h-4 text-gray-400" />
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="space-y-6">
          <div className="flex items-center text-sm text-gray-400 justify-between">
            <button
              onClick={() => {
                // Reset states when going back to storage selection
                setDestStorage(null); // Reset destination selection
                setDestProvider(null); // Reset the selected provider
                setDestFormData({}); // Reset form data
        
             
              }}
              className="bg-blue-500 text-white px-4 py-2 rounded-md flex items-center space-x-2 hover:bg-blue-600 transition-all"
            >
              <span>Back to Storage Selection</span>
            </button>
          </div>

          {destDiskMessage && (
            <div className="bg-green-900 p-4 rounded-lg mb-4">
              <span className="text-white-800">{destDiskMessage}</span>
            </div>
          )}

          {destFolderContents && destFolderContents.contents && destFolderContents.contents.length > 0 && (
            <div className="bg-gray-900 p-4 rounded-lg border border-gray-700 overflow-y-auto max-h-60">
              <div className="font-medium capitalize text-gray-300">Folder Contents</div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {destFolderContents.contents.map((folder) => (
                  <button
                    key={folder.fdloc}
                    onClick={() => handleDestItemClick(folder)} // Pass folder to item click handler
                    className={`flex items-center p-4 border border-gray-700 transition-all rounded-lg ${
                      destSelectedItems.has(folder.fdloc) ? 'bg-blue-800 border-blue-500' : 'hover:border-blue-500 hover:bg-blue-800'
                    }`}
                  >
                    <HardDrive className="w-5 h-5 mr-3 text-gray-300" />
                    <span className="flex-1 text-left text-gray-300">
                      {folder.name} <span className={`ml-2 ${folder.is_dir ? 'text-green-500' : 'text-red-500'}`}>
                        {folder.is_dir ? "Folder" : "File"}
                      </span>
                    </span>
                    <ChevronRight className="w-4 h-4 text-gray-400" />
                  </button>
                ))}
              </div>
            </div>
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {destProvider?.fields?.map((field) => (
              <div key={field.name} className="space-y-2 flex items-center">
                <label className="text-sm font-medium text-gray-300 flex items-center">
                  {field.name.toLowerCase().includes('password') ? (
                    <Lock className="w-5 h-5 text-blue-400 mr-2" />
                  ) : (
                    <User className="w-5 h-5 text-blue-400 mr-2" />
                  )}
                  {field.name}
                </label>
                <Input
                  type={field.name.toLowerCase().includes('password') ? 'password' : 'text'}
                  value={destFormData[field.name] || ''}
                  onChange={(e) => handleDestInputChange(field.name, e.target.value)}
                  placeholder={`e.g., ${field.example}`}
                  className={`border ${destFieldErrors[field.name] ? 'border-red-500' : 'border-gray-700'} bg-gray-900 text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent rounded-md`}
                  required={field.required}
                  pattern={field.pattern}
                />
              </div>
            ))}
          </div>

          <div className="flex justify-end pt-4">
            <button
              onClick={handleDestApply}
              className={`px-4 py-2 ${destStorage ? 'bg-blue-600' : 'bg-gray-500 cursor-not-allowed'} text-white rounded-md hover:bg-blue-700 flex items-center space-x-2`}
              disabled={!destStorage} // Disable if no destination storage is selected
            >
              <span>Apply Dest Configuration</span>
              <Check className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const SourceConfiguration = ({
  srcLocalStorage,
  srcStorageTypes,
  srcStorage,
  setSrcStorage,
  srcFolderContents,
  srcDiskMessage,
  handleSrcDiskClick,
  handleSrcStorageSelect,
  srcSelectedItems,
  handleSrcItemClick,
  srcProvider,
  setSrcProvider,
  srcFormData,
  setSrcFormData,
  handleSrcInputChange,
  handleSrcApply,
  srcFieldErrors,
}) => {
  return (
    <div className="p-6">
      {!srcStorage ? (
        <div className="space-y-4">
          {/* Local Storage Box */}
          {srcLocalStorage.length > 0 && (
            <div className="bg-gray-900 p-4 rounded-lg border border-gray-700 overflow-y-auto max-h-60">
              <div className="font-medium capitalize text-gray-300">Local Storage</div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {srcLocalStorage.map((option) => (
                  <button
                    key={`${option.fdloc}`}
                    onClick={() => {
                      setSrcStorage(option);
                      handleSrcDiskClick(option, true); // Pass isSource as true
                    }}
                    className={`flex items-center p-4 border border-gray-700 hover:border-blue-500 hover:bg-blue-800 transition-all rounded-lg ${
                      srcStorage === option ? 'bg-blue-600' : ''
                    }`}
                  >
                    <HardDrive className="w-5 h-5 mr-3 text-gray-300" />
                    <span className="flex-1 text-left text-gray-300">{option.name}</span>
                    <ChevronRight className="w-4 h-4 text-gray-400" />
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Other Storage Options */}
          {srcStorageTypes.map((storage) => (
            <div key={storage.type} className="bg-gray-900 p-4 rounded-lg border border-gray-700 overflow-y-auto max-h-60">
              <div className="font-medium capitalize text-gray-300">{`${storage.type} Storage`}</div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {storage.options.map((option) => (
                  <button
                    key={option.id}
                    onClick={() => {
                      setSrcStorage(option);
                      handleSrcStorageSelect(storage.type, option);
                      //handleSrcDiskClick(option, true); // Pass isSource as true
                    }}
                    className="flex items-center p-4 border border-gray-700 hover:border-blue-500 hover:bg-blue-800 transition-all rounded-lg"
                  >
                    {storage.type === 'cloud' && <Cloud className="w-5 h-5 mr-3 text-gray-300" />}
                    {storage.type === 'nas' && <Server className="w-5 h-5 mr-3 text-gray-300" />}
                    <span className="flex-1 text-left text-gray-300">{option.name}</span>
                    <ChevronRight className="w-4 h-4 text-gray-400" />
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="space-y-6">
          <div className="flex items-center text-sm text-gray-400 justify-between">
            <button
              onClick={() => {
                // Reset states when going back to storage selection
                setSrcStorage(null); // Reset source selection
                setSrcProvider(null); // Reset provider
                setSrcFormData({}); // Clear form data
              }}
              className="bg-blue-500 text-white px-4 py-2 rounded-md flex items-center space-x-2 hover:bg-blue-600 transition-all"
            >
              <ArrowLeftCircle className="w-4 h-4" />
              <span>Back to Storage Selection</span>
            </button>
          </div>

          {srcDiskMessage && (
            <div className="bg-green-900 p-4 rounded-lg mb-4">
              <span className="text-white-800">{srcDiskMessage}</span>
            </div>
          )}

          {srcFolderContents && srcFolderContents.contents && srcFolderContents.contents.length > 0 && (
            <div className="bg-gray-900 p-4 rounded-lg border border-gray-700 overflow-y-auto max-h-60">
              <div className="font-medium capitalize text-gray-300">Folder Contents</div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {srcFolderContents.contents.map((folder) => (
                  <button
                    key={folder.fdloc}
                    onClick={() => handleSrcItemClick(folder)} // Pass folder to item click handler
                    className={`flex items-center p-4 border border-gray-700 transition-all rounded-lg ${
                      srcSelectedItems.has(folder.fdloc) ? 'bg-blue-600 border-blue-500' : 'hover:border-blue-500 hover:bg-blue-800'
                    }`}
                  >
                    <HardDrive className="w-5 h-5 mr-3 text-gray-300" />
                    <span className="flex-1 text-left text-gray-300">
                      {folder.name} <span className={`ml-2 ${folder.is_dir ? 'text-green-500' : 'text-red-500'}`}>
                        {folder.is_dir ? "Folder" : "File"}
                      </span>
                    </span>
                    <ChevronRight className="w-4 h-4 text-gray-400" />
                  </button>
                ))}
              </div>
            </div>
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {srcProvider?.fields?.map((field) => (
              <div key={field.name} className="space-y-2 flex items-center">
                <label className="text-sm font-medium text-gray-300 flex items-center">
                  {field.name.toLowerCase().includes('password') ? (
                    <Lock className="w-5 h-5 text-blue-400 mr-2" />
                  ) : (
                    <User className="w-5 h-5 text-blue-400 mr-2" />
                  )}
                  {field.name}
                </label>
               <input
                  type={field.name.toLowerCase().includes('password') ? 'password' : 'text'}
                  value={srcFormData[field.name] || ''}
                  onChange={(e) => handleSrcInputChange(field.name, e.target.value)}
                  // Use the correct field errors here
                  className={`w-full p-2 border ${srcFieldErrors[field.name] ? 'border-red-500' : 'border-gray-700'} bg-gray-900 text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent rounded-md`}
                  placeholder={`e.g., ${field.example}`}
                  required={field.required}
                  pattern={field.pattern}
                />
              </div>
            ))}
          </div>

          <div className="flex justify-end pt-4">
            <button
              onClick={handleSrcApply}
              className={`px-4 py-2 ${srcStorage ? 'bg-blue-600' : 'bg-gray-500 cursor-not-allowed'} text-white rounded-md hover:bg-blue-700 flex items-center space-x-2`}
              disabled={!srcStorage} // Disable if no source storage is selected
            >
              <span>Apply Source Configuration</span>
              <Check className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};


const BackupConfigModal = ({ isOpen, onClose, config, onConfirm, width = 'default' }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  //console.log("config",config)

  useEffect(() => {
    if (isOpen) {
      setIsAnimating(true);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const formatSchedule = (schedule) => {
    if (!schedule) return 'Not set';
    return `${schedule.time} on ${schedule.days.join(', ')}`;
  };

  const widthClasses = {
    small: 'max-w-lg',
    default: 'max-w-2xl',
    large: 'max-w-4xl',
    full: 'max-w-[95vw]',
  }[width] || 'max-w-2xl';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />


      
      {/* Modal Container */}
      <div
        className={`
          ${widthClasses}
          w-full transform transition-all duration-300 ease-out
          ${isAnimating ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}
        `}
      >
        <div className="relative bg-gradient-to-b from-slate-900 to-slate-800 text-slate-100 rounded-lg shadow-2xl border border-slate-700">
          {/* Header */}
          <div className="p-6 border-b border-slate-700/50">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-semibold">Backup Configuration Review</h2>
              <button 
                className="p-2 text-slate-400 hover:text-slate-100 rounded-full hover:bg-slate-700/50 transition-colors"
                onClick={onClose}
              >
                <X className="h-5 w-5" />
              </button>
            </div>
          </div>

          {/* Content Area */}
          <div className="max-h-[calc(80vh-8rem)] overflow-y-auto">
              

            <div className="p-6 space-y-8">
               {/* Configuration Overview */}
               <div className="bg-slate-800/50 rounded-lg p-4 border border-slate-700/50">
                <div className="flex items-center space-x-3 text-sm text-slate-400">
                  <Shield className="h-4 w-4" />
                  <span>Configuration ID: {Math.random().toString(36).substr(2, 9).toUpperCase()}</span>
                </div>
              </div>
              {/* Basic Info Section */}
              <Section
                icon={<HardDrive className="h-5 w-5 text-blue-400" />}
                title="Basic Configuration"
              >
                <div className="grid grid-cols-2 gap-6">
                  <InfoCard label="Backup Scope" value={config.backupScope} />
                  <InfoCard label="Backup Type" value={config.backupType.join(', ')} />
                </div>
              </Section>

                {/* Schedule Section */}
                <Section
                icon={<Calendar className="h-5 w-5 text-green-400" />}
                title="Schedule & Retention"
              >
                <div className="space-y-6">
                  <div className="grid grid-cols-2 gap-6">
                    <InfoCard label="Frequency" value={config.frequency} />
                    <InfoCard label="Custom Schedule" value={formatSchedule(config.customSchedule)} />
                  </div>
                  <div className="bg-slate-800 rounded-lg p-4 border border-slate-700/50">
                    <h4 className="text-sm font-medium text-slate-300 mb-3">Retention Policy</h4>
                    <div className="grid grid-cols-3 gap-4 text-sm">
                      <div className="p-3 bg-slate-700/30 rounded-lg">
                        <div className="text-slate-400">Versions</div>
                        <div className="text-lg font-semibold">{config.retention.versions}</div>
                      </div>
                      <div className="p-3 bg-slate-700/30 rounded-lg">
                        <div className="text-slate-400">Period</div>
                        <div className="text-lg font-semibold">{config.retention.period} days</div>
                      </div>
                      <div className="p-3 bg-slate-700/30 rounded-lg">
                        <div className="text-slate-400">Delete After</div>
                        <div className="text-lg font-semibold">{config.retention.deleteAfter} days</div>
                      </div>
                    </div>
                  </div>
                </div>
              </Section>

              {/* Data Selection Section */}
              <Section
                icon={<Filter className="h-5 w-5 text-yellow-400" />}
                title="Data Selection"
              >
                <div className="space-y-6">
                  {/* Include Patterns */}
                  <div className="flex flex-col space-y-2">
                    <label className="block text-sm text-gray-300">Include Patterns</label>
                    <ul className="list-disc pl-4 text-sm">
                      {/* Check if includePatterns is an array, otherwise wrap it in an array */}
                      {(Array.isArray(config.includePatterns) ? config.includePatterns : [config.includePatterns]).map((pattern, index) => (
                        <li key={index}>{pattern}</li>
                      ))}
                    </ul>
                  </div>
                  
                  {/* Exclude Patterns */}
                  <div className="flex flex-col space-y-2">
                    <label className="block text-sm text-gray-300">Exclude Patterns</label>
                    <ul className="list-disc pl-4 text-sm">
                      {/* Check if excludePatterns is an array, otherwise wrap it in an array */}
                      {(Array.isArray(config.excludePatterns) ? config.excludePatterns : [config.excludePatterns]).map((pattern, index) => (
                        <li key={index}>{pattern}</li>
                      ))}
                    </ul>
                  </div>

                  {/* Quick Selection */}
                  <div className="space-y-2">
                    <h4 className="text-sm font-medium text-gray-300">Quick Selection</h4>
                    <ul className="list-disc ml-4 text-sm">
                      {['System Files', 'User Data', 'Applications', 'Databases'].map(item => (
                        <li key={item}>
                          {config.quickSelections.includes(item) ? (
                            <span className="text-green-400">{item}</span>
                          ) : (
                            <span>{item}</span>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Compression Information */}
                  {config.compress && (
                    <div className="text-sm text-green-500">
                      <p>Compression is enabled for the backup.</p>
                    </div>
                  )}
                </div>
              </Section>

              {/* Source Configuration Section */}
              <Section
                icon={<Server className="h-5 w-5 text-purple-400" />}
                title="Source Configuration"
              >
                <div className="space-y-6">
                  <InfoCard 
                    label="Source Provider" 
                    value={config.srcProvider} 
                    variant="large"
                  />
                  {config.srcFormData && Object.keys(config.srcFormData).length > 0 && (
                    <div className="bg-slate-800 rounded-lg p-4 border border-slate-700/50">
                      <h4 className="text-sm font-medium text-slate-300 mb-3">Source Connection Details</h4>
                      <div className="space-y-2">
                        {Object.entries(config.srcFormData).map(([key, value]) => (
                          <div key={key} className="flex items-center justify-between py-2 border-b border-slate-700/50 last:border-0">
                            <span className="text-slate-400">{key}</span>
                            <span className="font-mono text-sm">
                              {key.toLowerCase().includes('password') ? '••••••' : value}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {config.srcPathContents && config.srcPathContents.length > 0 && (
                    <div className="bg-slate-800 rounded-lg p-4 border border-slate-700/50">
                      <h4 className="text-sm font-medium text-slate-300 mb-3">Source Path Contents</h4>
                      <div className="max-h-48 overflow-y-auto">
                        {config.srcPathContents.map((item, index) => (
                          <div key={index} className="flex justify-between py-1">
                            <span className="text-slate-400">{item.is_dir ? 'Folder' : 'Path'}: {item.name}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </Section>

              {/* Destination Configuration Section */}
              <Section
                icon={<Server className="h-5 w-5 text-purple-400" />}
                title="Destination Configuration"
              >
                <div className="space-y-6">
                  <InfoCard 
                    label="Destination Provider" 
                    value={config.dstProvider} 
                    variant="large"
                  />
                  {config.dstFormData && Object.keys(config.dstFormData).length > 0 && (
                    <div className="bg-slate-800 rounded-lg p-4 border border-slate-700/50">
                      <h4 className="text-sm font-medium text-slate-300 mb-3">Connection Details</h4>
                      <div className="space-y-2">
                        {Object.entries(config.dstFormData).map(([key, value]) => (
                          <div key={key} className="flex items-center justify-between py-2 border-b border-slate-700/50 last:border-0">
                            <span className="text-slate-400">{key}</span>
                            <span className="font-mono text-sm">
                              {key.toLowerCase().includes('password') ? '••••••' : value}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                 {config.destPathContents && config.destPathContents.length > 0 && (
                    <div className="bg-slate-800 rounded-lg p-4 border border-slate-700/50">
                      <h4 className="text-sm font-medium text-slate-300 mb-3">Destination Path Contents</h4>
                      <div className="max-h-48 overflow-y-auto">
                        {config.destPathContents.map((item, index) => (  // Consistent naming 'item'
                          <div key={index} className="flex justify-between py-1">
                            <span className="text-slate-400">{item.is_dir ? 'Folder' : 'File'}: {item.name}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </Section>
            </div>
          </div>

          {/* Footer */}
          <div className="p-6 border-t border-slate-700/50 bg-slate-800/50">
            <div className="flex items-center justify-between">
              <div className="text-sm text-slate-400">
                Review your configuration before proceeding
              </div>
              <div className="flex gap-3">
                <button 
                  className="px-4 py-2 flex items-center gap-2 text-slate-300 hover:text-slate-100 bg-slate-700/50 hover:bg-slate-700 rounded-lg transition-colors"
                  onClick={onClose}
                >
                  <XCircle className="h-4 w-4" />
                  Cancel
                </button>
                <button 
                  className="px-6 py-2 flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors font-medium"
                  onClick={onConfirm}
                >
                  <Save className="h-4 w-4" />
                  Confirm Backup
                  <ChevronRight className="h-4 w-4" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Helper Components
const Section = ({ icon, title, children }) => (
  <div className="space-y-4">
    <div className="flex items-center gap-2 pb-2 border-b border-slate-700/50">
      {icon}
      <h3 className="text-lg font-medium">{title}</h3>
    </div>
    <div className="pl-7">
      {children}
    </div>
  </div>
);

const InfoCard = ({ label, value, variant = 'default' }) => (
  <div className={`${variant === 'large' ? 'col-span-2' : ''}`}>
    <div className="text-sm text-slate-400 mb-1">{label}</div>
    <div className="font-medium">{value}</div>
  </div>
);



const BackupSystem = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('backup');
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [storageDevices, setStorageDevices] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalMessage, setModalMessage] = useState('');
  const hasFetchedSource = useRef(false); 
  const hasFetchedDestination = useRef(false); 
  const [backupConfig, setBackupConfig] = useState({
    scope: '',
    type: '',
    frequency: '',
    customSchedule: {
      time: '00:00',
      days: []
    },
    
    retention: '30',
    notifications: {
      success: true,
      failure: true,
      warning: true
    }
  });

  //console.log("backupConfig", backupConfig)

 
    const [config, setConfig] = useState({
      systems: [],
      schedule: {
        type: 'recurring',
        template: 'daily',
        customSchedule: {
          time: '00:00',
          days: [],
          timezone: 'UTC'
        }
      },
      storage: {
        type: 'local',        
        encryption: false,
        location: '',
        cloudProvider: '',
        credentials: {}
      },
      retention: {
        type: 'manual',        
        versions: '3',
        deleteAfter: '90',        
      },
      compress: false, 
      backupType: 'full',
      dataSelection: {
        inclusions: [],
        exclusions: [],
        rules: []
      }
    });

    const [selectedStorage, setSelectedStorage] = useState(null);
    const [selectedProvider, setSelectedProvider] = useState(null);
    const [formData, setFormData] = useState({});
    // To hold dynamically fetched local storage options
    const [localStorageOptions, setLocalStorageOptions] = useState([]);
    const [folderContents, setFolderContents] = useState([]);
    const [selectedDiskMessage, setSelectedDiskMessage] = useState('');
    const [selectedItems, setSelectedItems] = useState(new Set()); // To track selected items
    const [lastClickTime, setLastClickTime] = useState(0);
    const [selectedSourceStorage, setSelectedSourceStorage] = useState(null);
    const [selectedDestinationStorage, setSelectedDestinationStorage] = useState(null);

    // The static structure for cloud and NAS options
    
    const sourceStorageTypes = [
      {
        type: 'cloud',
        options: [
          { 
            id: 'aws', 
            name: 'Amazon Web Services',
            fields: [
              { name: 'Access Key', required: true, example: 'AKIAIOSFODNN7EXAMPLE' },
              { name: 'Secret Key', required: true, example: 'wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY' },
              { name: 'Region', required: true, example: 'us-west-2' },
              { name: 'Bucket Name', required: true, example: 'my-backup-bucket' }
            ]
          },
          { 
            id: 'gcp', 
            name: 'Google Cloud Platform',
            fields: [
              { name: 'Project ID', required: true, example: 'my-gcp-project' },
              { name: 'Service Account Key', required: true, example: 'path/to/service-account-key.json' },
              { name: 'Bucket Name', required: true, example: 'my-gcp-bucket' }
            ]
          },
          { 
            id: 'azure', 
            name: 'Microsoft Azure',
            fields: [
              { name: 'Account Name', required: true, example: 'myazureaccount' },
              { name: 'Account Key', required: true, example: 'myaccountkey' },
              { name: 'Container Name', required: true, example: 'my-container' }
            ]
          }
        ]
      },
      {
        type: 'nas',
        options: [
          {
            id: 'nas',
            name: 'Network Attached Storage',
            fields: [
              { name: 'IP Address', required: false, example: '192.167.3.5', pattern: '^\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}$' },
              { name: 'Share Name', required: true, example: 'shared-folder' },
              { name: 'Username', required: true, example: 'nas-user' },
              { name: 'Password', required: true, example: 'password' }
            ]
          }
        ]
      }
    ];
    
    const destinationStorageTypes = [
      {
        type: 'cloud',
        options: [
          { 
            id: 'aws-destination', 
            name: 'Amazon Web Services',
            fields: [
              { name: 'Access Key', required: true, example: 'AKIAIOSFODNN7EXAMPLE' },
              { name: 'Secret Key', required: true, example: 'wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY' },
              { name: 'Region', required: true, example: 'us-west-2' },
              { name: 'Bucket Name', required: true, example: 'my-backup-bucket' }
            ]
          },
          { 
            id: 'gcp-destination', 
            name: 'Google Cloud Platform',
            fields: [
              { name: 'Project ID', required: true, example: 'my-gcp-project' },
              { name: 'Service Account Key', required: true, example: 'path/to/service-account-key.json' },
              { name: 'Bucket Name', required: true, example: 'my-gcp-bucket' }
            ]
          },
          { 
            id: 'azure-destination', 
            name: 'Microsoft Azure',
            fields: [
              { name: 'Account Name', required: true, example: 'myazureaccount' },
              { name: 'Account Key', required: true, example: 'myaccountkey' },
              { name: 'Container Name', required: true, example: 'my-container' }
            ]
          }
        ]
      },
      {
        type: 'nas',
        options: [
          {
            id: 'nas-destination',
            name: 'Network Attached Storage',
            fields: [
              { name: 'IP Address', required: true, example: '192.167.3.5', pattern: '^\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}$' },
              { name: 'Share Name', required: true, example: 'shared-folder' },
              { name: 'Username', required: true, example: 'nas-user' },
              { name: 'Password', required: true, example: 'password' }
            ]
          }
        ]
      }
    ];
    

    // State Variables for Source Modal
    const [sourceLocalStorageOptions, setSourceLocalStorageOptions] = useState([]);
   
    const [sourceFolderContents, setSourceFolderContents] = useState([]);
    const [selectedSourceDiskMessage, setSelectedSourceDiskMessage] = useState('');
    const [selectedSourceProvider, setSelectedSourceProvider] = useState('');
    const [sourceFormData, setSourceFormData] = useState({});
    const [sourceFieldErrors, setSourceFieldErrors] = useState({});
    const [modalVariant, setModalVariant] = useState('info'); 
    
    
    // State Variables for Destination Modal
    const [destinationLocalStorageOptions, setDestinationLocalStorageOptions] = useState([]);
   
    const [destinationFolderContents, setDestinationFolderContents] = useState([]);
    const [selectedDestinationDiskMessage, setSelectedDestinationDiskMessage] = useState('');
    const [selectedDestinationProvider, setSelectedDestinationProvider] = useState('');
    const [destinationFormData, setDestinationFormData] = useState({});
    const [destinationFieldErrors, setDestinationFieldErrors] = useState({});

    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);

    const notifications = [
      { id: 1, status: 'success', message: 'Backup completed successfully', time: '2 minutes ago' },
      { id: 2, status: 'pending', message: 'Backup in progress...', time: '5 minutes ago' },
      { id: 3, status: 'info', message: 'New backup scheduled', time: '1 hour ago' }
    ];

    const getSectionDetails = (section) => {
      switch(section) {
        case 'dashboard':
          return {
            title: 'Dashboard Overview',
            description: 'System performance and backup status',
            lastUpdated: '2 minutes ago'
          };
        case 'backup':
          return {
            title: 'Backup Configuration',
            description: 'Manage backup settings and schedules',
            lastUpdated: '5 minutes ago'
          };
        default:
          return {
            title: 'Dashboard',
            description: 'Overview',
            lastUpdated: 'Just now'
          };
      }
    };

    const sectionInfo = getSectionDetails(activeSection);


    // Fetch Storage Devices for Source Modal
    useEffect(() => {
      const fetchSourceStorageDevices = async () => {
        try {
          if (hasFetchedSource.current) return;
          hasFetchedSource.current = true;

          const response = await fetch('/backup_ls_disk');
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          setSourceLocalStorageOptions(data.contents);
        } catch (err) {
          console.error('Failed to fetch source storage devices:', err);
        }
      };
      fetchSourceStorageDevices();
    }, []);

    // Fetch Storage Devices for Destination Modal
    useEffect(() => {
      const fetchDestinationStorageDevices = async () => {
        try {
          if (hasFetchedDestination.current) return;
          hasFetchedDestination.current = true;

          const response = await fetch('/backup_ls_disk');
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          setDestinationLocalStorageOptions(data.contents);
        } catch (err) {
          console.error('Failed to fetch destination storage devices:', err);
        }
      };
      fetchDestinationStorageDevices();
    }, []);

   
    
     // Functions for Source Modal
      const handleSourceDiskClick = async (device) => {      
        const isFolderAllowed = config.systems.includes('2'); // Folder Backup
        const isFileAllowed = config.systems.includes('3');   // File Backup

        if (!isFolderAllowed && !isFileAllowed) {
          setSelectedSourceDiskMessage(`You have selected ${device.name} for backup in source. Please click 'Apply Configuration' once you have filled in the required information.`);
          setSelectedSourceStorage(device);
          setSourceFolderContents([]);
          return; 
        }

        let apiUrl;
        if (isFolderAllowed) {
          apiUrl = '/backup_ls_folders'; // API endpoint for folder contents
        } else if (isFileAllowed) {
          apiUrl = '/backup_ls_files'; // API endpoint for file contents
        }

        try {
          const response = await fetch(apiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ fdloc: device.fdloc }) 
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const result = await response.json();
          setSourceFolderContents(result);
          setSelectedSourceStorage(device); // Highlight the selected disk
          setSelectedSourceDiskMessage(''); // Clear previous message
        } catch (err) {
          console.error('Failed to fetch contents:', err);
          alert('Failed to load contents. Please try again later.');
        }
      };

      const handleSourceStorageSelect = (type, option) => {
     
        setSelectedSourceStorage(option);
        if (type === 'cloud' || type === 'nas') {
          setSelectedSourceProvider(option);
          setSourceFormData({});  // Reset form data for new provider
        }
      };

      const handleSourceItemClick = (folder) => {
        const clickTime = new Date().getTime();

        if (folder.is_dir) {
          const isFolderAllowed = config.systems.includes('2');
          if (isFolderAllowed) {
            // Check for double-click (within 300ms)
            if (clickTime - lastClickTime < 300 && lastClickTime !== 0) {
              handleSourceDiskClick(folder); // Fetch new content
              setLastClickTime(0);
            } else {
              // Single click on directory, toggle selection
              const newSelectedItems = new Set(selectedItems);
              if (newSelectedItems.has(folder.fdloc)) {
                newSelectedItems.delete(folder.fdloc);
              } else {
                newSelectedItems.add(folder.fdloc);
              }
              setSelectedItems(newSelectedItems);
              setLastClickTime(clickTime);
            }
          }
        } else {
          // Handle file selection
          const newSelectedItems = new Set(selectedItems);
          if (newSelectedItems.has(folder.fdloc)) {
            newSelectedItems.delete(folder.fdloc);
          } else {
            newSelectedItems.add(folder.fdloc);
          }
          setSelectedItems(newSelectedItems);
          setLastClickTime(0);
        }
      };

      // Functions for Destination Modal
      const handleDestinationDiskClick = async (device) => {
        const isFolderAllowed = config.systems.includes('2'); // Folder Backup
        const isFileAllowed = config.systems.includes('3');   // File Backup

        if (!isFolderAllowed && !isFileAllowed) {
          setSelectedDestinationDiskMessage(`You have selected ${device.name} for backup in destination. Please click 'Apply Configuration' once you have filled in the required information.`);
          setSelectedDestinationStorage(device);
          setDestinationFolderContents([]);
          return; 
        }

        let apiUrl;
        if (isFolderAllowed) {
          apiUrl = '/backup_ls_folders'; // API endpoint for folder contents
        } else if (isFileAllowed) {
          apiUrl = '/backup_ls_files'; // API endpoint for file contents
        }

        try {
          const response = await fetch(apiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ fdloc: device.fdloc }) 
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const result = await response.json();
          setDestinationFolderContents(result);
          setSelectedDestinationStorage(device); // Highlight the selected disk
          setSelectedDestinationDiskMessage(''); // Clear previous message
        } catch (err) {
          console.error('Failed to fetch contents:', err);
          alert('Failed to load contents. Please try again later.');
        }
      };

      const handleDestinationStorageSelect = (type, option) => {
        setSelectedDestinationStorage(option);
        if (type === 'cloud' || type === 'nas') {
          setSelectedDestinationProvider(option);
          setDestinationFormData({});  // Reset form data for new provider
        }
      };

      const handleDestinationItemClick = (folder) => {
        const clickTime = new Date().getTime();

        if (folder.is_dir) {
          const isFolderAllowed = config.systems.includes('2');
          if (isFolderAllowed) {
            // Check for double-click (within 300ms)
            if (clickTime - lastClickTime < 300 && lastClickTime !== 0) {
              handleDestinationDiskClick(folder); // Fetch new content
              setLastClickTime(0);
            } else {
              // Single click on directory, toggle selection
              const newSelectedItems = new Set(selectedItems);
              if (newSelectedItems.has(folder.fdloc)) {
                newSelectedItems.delete(folder.fdloc);
              } else {
                newSelectedItems.add(folder.fdloc);
              }
              setSelectedItems(newSelectedItems);
              setLastClickTime(clickTime);
            }
          }
        } else {
          // Handle file selection
          const newSelectedItems = new Set(selectedItems);
          if (newSelectedItems.has(folder.fdloc)) {
            newSelectedItems.delete(folder.fdloc);
          } else {
            newSelectedItems.add(folder.fdloc);
          }
          setSelectedItems(newSelectedItems);
          setLastClickTime(0);
        }
      }; 
        

    const isFormValid = () => {
      // Check if formData contains all required fields
      return selectedProvider?.fields?.every(field => {
        // Adjust this condition based on your validation logic
        return field.required ? !!formData[field.name] : true;
      });
    };

    
    const [showSourceModal, setShowSourceModal] = useState(false);
    const [showDestinationModal, setShowDestinationModal] = useState(false);

    // Modified handleApply function
    const handleSrcApply = () => {
      // Handle your apply logic here
      // Optionally you can reset fields related to the modal that was just closed.
      
      // Close the relevant modal depending on which one is currently displayed
      if (showSourceModal) {
        setShowSourceModal(false);
      } 
    };

    const handleDestinationApply = () => {  
      // Close the relevant modal depending on which one is currently displayed
      if (showDestinationModal) {
        setShowDestinationModal(false);
      }
    };

    // Example button to open source modal
    const openSourceModal = () => {
      setShowSourceModal(true);
      setShowDestinationModal(false); // Close destination if it's open
    };

    // Example button to open destination modal
    const openDestinationModal = () => {
      setShowDestinationModal(true);
      setShowSourceModal(false); // Close source if it's open
    };



       const Modal = ({ isOpen, onClose, title, children }) => {
            if (!isOpen) return null;
          
            return (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-gray-800 rounded-lg w-full max-w-md mx-4 relative">
                  {/* Modal Header */}
                  <div className="flex items-center justify-between p-4 border-b border-gray-700">
                    <h2 className="text-lg font-semibold text-gray-300">{title}</h2>
                    <button
                      onClick={onClose}
                      className="text-gray-400 hover:text-gray-200 focus:outline-none"
                    >
                      <X className="w-5 h-5" />
                    </button>
                  </div>
          
                  {/* Modal Content */}
                  <div className="p-4">
                    {children}
                  </div>
                </div>
              </div>
            );
          };
  
  
  

  const [validationErrors, setValidationErrors] = useState({});

  const [fieldErrors, setFieldErrors] = useState({});

  const handleInputChange = (field, value, pattern) => {
    const isValid = pattern ? new RegExp(pattern).test(value) : true;
    setFormData({ ...formData, [field]: value });
    setFieldErrors({ ...fieldErrors, [field]: !isValid });
  };

  const handleModalOpen = (type) => {
    setModalContent(type); // Set the content based on the type
    setShowModal(true);    // Show the modal
  };

  const handleSrcDiskChange = (option) => {    
    setBackupConfig((prevBackupConfig) => ({
      ...prevBackupConfig,
      selectedSourceStorage: option, // Assign the full object
    }));
  };
  
  const handleDstDiskChange = (option) => {
    setBackupConfig((prevBackupConfig) => ({
      ...prevBackupConfig,
      selectedDestinationStorage: option, // Assign the full object
    }));
  };

  
 

  // Custom Button Component
  const Button = ({ children, variant = 'primary', onClick, className = '' }) => {
    const baseStyles = 'px-4 py-2 rounded transition-colors duration-200 flex items-center';
    const variants = {
      primary: 'bg-blue-600 hover:bg-blue-700',
      secondary: 'bg-gray-700 hover:bg-gray-600',
      danger: 'bg-red-600 hover:bg-red-700'
    };

    return (
      <button
        onClick={onClick}
        className={`${baseStyles} ${variants[variant]} ${className}`}
      >
        {children}
      </button>
    );
  };

  

  // Custom Select Component
  const Select = ({ value, onChange, options, className = '' }) => (
    <select
      value={value}
      onChange={onChange}
      className={`w-full bg-gray-700 rounded p-2 border border-gray-600 focus:border-blue-500 focus:outline-none ${className}`}
    >
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );

  const availableSystems = [
    { id: '1', name: 'Full System Backup', type: 'full' }, 
    { id: '2', name: 'Selected Folders Backup', type: 'folder' },
    { id: '3', name: 'Selected Files Backup', type: 'file' },
    { id: '4', name: 'Web Server', type: 'application' },
    { id: '5', name: 'Database Server', type: 'database' },
    { id: '6', name: 'File Server', type: 'storage' },
    { id: '7', name: 'Email Server', type: 'communication' },
    { id: '8', name: 'Backup Server', type: 'storage' },
    { id: '9', name: 'DNS Server', type: 'network' },
    { id: '10', name: 'FTP Server', type: 'file transfer' },
    { id: '11', name: 'Game Server', type: 'entertainment' },
    { id: '12', name: 'Print Server', type: 'peripheral' },
    { id: '13', name: 'Proxy Server', type: 'network' }
];

const handleRetentionTypeChange = (event) => {
  setConfig({
    ...config,
    retention: {
      ...config.retention,
      type: event.target.value,
    },
  });
};

const handleVersionsChange = (event) => {
  // Convert the input value to a number
  const value = Number(event.target.value);

  // Check if the value is between 1 and 100
  if (value >= 1 && value <= 100) {
      setConfig({
          ...config,
          retention: {
              ...config.retention,
              versions: value,  // Only update if it's valid
          },
      });
  } else if (event.target.value === "") {
      // Allow empty input (optional)
      setConfig({
          ...config,
          retention: {
              ...config.retention,
              versions: "",  // Allow clearing the input
          },
      });
  } else {
      // Handle invalid input (optional: show a message, etc.)
      alert("Keep Versions must be between 1 and 100.");
  }
};

const handleDeleteAfterChange = (event) => {
  // Convert the input value to a number
  const value = Number(event.target.value);

  // Check if the value is at least 1
  if (value >= 0 && value <= 36500) {
      setConfig({
          ...config,
          retention: {
              ...config.retention,
              deleteAfter: value,  // Only update if it's valid
          },
      });
  } else if (event.target.value === "") {
      // Allow empty input (optional)
      setConfig({
          ...config,
          retention: {
              ...config.retention,
              deleteAfter: "",  // Allow clearing the input
          },
      });
  } else {
      // Handle invalid input (optional: show a message, etc.)
      alert("Delete After must be at least 1 day or 0 for immediate.");
  }
};






const handleDestInputChange = (fieldName, value, pattern) => {
  //console.log(`Input change: ${fieldName} = ${value}`); // Log the input change
  setDestinationFormData((prevFormData) => {
    const updatedFormData = {
      ...prevFormData,
      [fieldName]: value
    };
    //console.log(`Updated form data:`, updatedFormData); // Log the updated form data
    return updatedFormData;
  }); 
};

//console.log("Selected Source Storage:", selectedSourceStorage);
//console.log("Selected Destination Storage:", selectedDestinationStorage);

const handleSrcInputChange = (fieldName, value, pattern) => {
  //console.log(`Input change: ${fieldName} = ${value}`); // Log the input change
  setSourceFormData((prevFormData) => {
    const updatedFormData = {
      ...prevFormData,
      [fieldName]: value
    };
    //console.log(`Updated form data:`, updatedFormData); // Log the updated form data
    return updatedFormData;
  });
};

const [isBackupPopupOpen, setIsBackupPopupOpen] = useState(false);

const [isBackupSummaryVisible, setBackupSummaryVisible] = useState(false);
const [currentBackupConfig, setCurrentBackupConfig] = useState(null);
const [includePatterns, setIncludePatterns] = useState([]);
  const [excludePatterns, setExcludePatterns] = useState([]);
  const [quickSelections, setQuickSelections] = useState({
    'System Files': false,
    'User Data': false,
    'Applications': false,
    'Databases': false,
  });

  // Change handlers
 // Change handlers
const handleIncludePatternsChange = (event) => {
  const value = event.target.value;
  setIncludePatterns(value.split(',').map((item) => item.trim())); // Split by comma and trim spaces
};

const handleExcludePatternsChange = (event) => {
  const value = event.target.value;
  setExcludePatterns(value.split(',').map((item) => item.trim())); // Split by comma and trim spaces
};


  const handleQuickSelectionChange = (item) => {
    setQuickSelections(prev => ({
      ...prev,
      [item]: !prev[item], // Toggle the selected state for the item
    }));
  };


const collectBackupConfigValues = () => {
  const availableSystemMap = availableSystems.reduce((map, system) => {
    map[system.id] = system.type;
    return map;
  }, {}); 

  //console.log("\nselectedSourceStorage:", selectedSourceStorage)
  //console.log("\nselectedItems:", selectedItems)

  
  
  const collectedValues = {
    backupScope: backupConfig.backupScope,
    frequency: backupConfig.frequency,
    retention: config.retention,
    dstProvider: selectedDestinationProvider?.name || 'Local Storage', 
    srcProvider: selectedSourceProvider?.name || 'Local Storage', 
    customSchedule: backupConfig.customSchedule,
    backupType: config.systems.map(id => availableSystemMap[id]),
    srcFormData: sourceFormData, // collected source form data
    dstFormData: destinationFormData, // collected destination form data
    compress: config.compress, 
    includePatterns,
    excludePatterns,
    quickSelections: Object.entries(quickSelections)
      .filter(([_, selected]) => selected) // Filter selected items
      .map(([item]) => item), // Map to the item names
    
    // Determine srcPathContents
    srcPathContents: sourceFolderContents.contents && sourceFolderContents.contents.length > 0
    ? sourceFolderContents.contents.map((content, index) => ({ // Return object with is_dir and name
      fdloc: content.fdloc,
      is_dir: content.is_dir,
      name: content.name
    }))
    : [selectedSourceStorage ? { name: selectedSourceStorage?.name } : {}],

    //dstLocalStorage: selectedDestinationProvider || 'LocalStorage',

    // Determine destPathContents
    destPathContents: destinationFolderContents.contents && destinationFolderContents.contents.length > 0
    ? destinationFolderContents.contents.map((content) => ({  // Consistent mapping
        fdloc: content.fdloc,
        is_dir: content.is_dir,
        name: content.name
      }))
    : [selectedDestinationStorage ? { name: selectedDestinationStorage.name } : {}],
  };

  //console.log('Collected Backup Configuration Values:', collectedValues);
  return collectedValues;
};

  // You can call this function on backup submission or any other relevant event
  const handleBackupSubmit = () => {    
    const validationErrors = validateConfig();
    //console.log('Validation Errors:', validationErrors); // Log validation errors
  
    if (validationErrors) {
      setValidationErrors(validationErrors);
      setModalOpen(true);
      setModalTitle('Validation Errors');    
      
      // Set the variant to 'error' since there are validation errors
      setModalVariant('error');
      return;
    }
  
    const allBackupConfigValues = collectBackupConfigValues();
    if (allBackupConfigValues) {
      //console.log('Configuration collected successfully:', allBackupConfigValues);
      
      // Set the modal state with collected config
      setCurrentBackupConfig(allBackupConfigValues); 
      setBackupSummaryVisible(true); // Open the modal to show the configuration summary
    } else {
      console.error('Backup submission failed due to validation errors');
    }  
  };

  const handleCompressionChange = (isEnabled) => {
    setConfig((prevConfig) => ({
      ...prevConfig,
      compress: isEnabled, // Update the compression state
    }));
  };

  const handleBackupConfirmation = async () => {
    const collectedValues = collectBackupConfigValues();
    
    // Validate collected values before proceeding
    const validationErrors = validateConfig(collectedValues);    
    if (validationErrors) {      
      // If there are validation errors, set errors and display modal
      setValidationErrors(validationErrors);
      setModalOpen(true);
      setModalTitle('Validation Errors');     
      
      // Set the variant to 'error' since there are validation errors
      setModalVariant('error');
  
      return; // Exit the function, do not proceed with the fetch
    }
  
    //console.log('Configuration collected successfully:', collectedValues);
    setBackupSummaryVisible(false);
    // Start the backup animation popup
    setIsBackupPopupOpen(true);
  
    try {
      const response = await fetch('/api/backup-config', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(collectedValues)
      });
    
      const data = await response.json(); 
      //console.log("data", data)
    
      if (response.ok) {
        setIsBackupPopupOpen(false);
        setValidationErrors({});
        setModalOpen(true);
        setModalTitle('Backup Configuration Successful');
        setModalMessage(data.message || 'Backup configuration has been submitted successfully.');        
        setModalVariant('success');
      } else {
        // Handle server-side errors
        setIsBackupPopupOpen(false);
        setModalOpen(true);
        setModalTitle('Error Submitting Backup Configuration');
    
        // Check if the error is a validation error or a general error
        const errorMessages = data.messages || data.message || 'An unexpected error occurred.';
        
        // Check if messages exist and format them
        const formattedMessages = typeof errorMessages === 'object'
          ? Object.entries(errorMessages)
              .map(([key, messages]) => `${key}: ${messages.join(', ')}`)
              .join('; ')
          : errorMessages;
    
        setModalMessage(formattedMessages);
        setValidationErrors(data.validationErrors || {});
        
        // Set the variant to 'error' for errors
        setModalVariant('error');
      }
    } catch (error) {
      //console.error('Error submitting backup configuration:', collectedValues, error);
      setIsBackupPopupOpen(false);
      setModalOpen(true);
      setModalTitle('Error Submitting Backup Configuration');
      setModalMessage('An error occurred while submitting the backup configuration.');
    
      // Set the variant to 'error' for catch block errors
      setModalVariant('error');
    }

    // Close the summary modal after confirmation
    setBackupSummaryVisible(false);
  };
  
  const validateConfig = () => {
    const errors = {};

    // Validate source storage types
    if (!selectedSourceStorage) {
      errors.selectedSourceStorage = 'Source location must be selected';
    }
  
    // Validate destination storage types
    if (!selectedDestinationStorage) {
      errors.selectedDestinationStorage = 'Destination location must be selected';
    }
  
    // Validate required fields for non-local storage options
    if (selectedDestinationProvider) {
      //console.log("selectedDestinationProvider", selectedDestinationProvider)
      const selectedDestination = destinationStorageTypes
      .flatMap(type => type.options)
      .find(option => option.id === selectedDestinationProvider.id);
       
  
      if (selectedDestination) {
        selectedDestination.fields.forEach(field => {
          if (field.required && !destinationFormData[field.name]) {
            errors[field.name] = `${field.name} is required.`;
          }
        });
      }
    }
  
   // Validation for source provider if applicable
    if (selectedSourceProvider) {
      //console.log("selectedSourceProvider", selectedSourceProvider)
      //console.log("sourceStorageTypes", sourceStorageTypes)
      // Assume that we may gather similar validation for source provider fields
      const selectedSource = sourceStorageTypes     
        .flatMap(type => type.options)
        .find(option => option.id === selectedSourceProvider.id); // Compare with selectedSourceProvider.id
        
      //console.log("selectedSource", selectedSource) // Log selectedSource instead
  
      if (selectedSource) {
        selectedSource.fields.forEach(field => {
          if (field.required && !sourceFormData[field.name]) {
            errors[field.name] = `${field.name} is required.`;
          }
        });
      }
    }
  
    // Validate backup configuration settings
    if (!backupConfig.backupScope) {
      errors.backupScope = 'Backup scope is required.';
    }
    
    /*if (!backupConfig.frequency) {
      errors.frequency = 'Backup frequency is required.';
    }*/
  
    // If frequency is custom, validate customSchedule properties
    if (backupConfig.frequency === 'custom') {
      if (!backupConfig.customSchedule.time) {
        errors.customScheduleTime = 'Custom schedule time is required when frequency is custom.';
      }
      if (backupConfig.customSchedule.days.length === 0) {
        errors.customScheduleDays = 'At least one day must be selected when using a custom schedule.';
      }
    }
  
    // Validate retention settings
    if (!backupConfig.retention) {
      errors.retention = 'Retention setting is required.';
    }
  
    // Validate selected systems (if applicable)
    if (config.systems.length === 0) {
      errors.systems = 'At least one system must be selected.';
    }
  
    return Object.keys(errors).length > 0 ? errors : null;
  };

  // Function to render the active content
  const renderActiveContent = () => {
    switch (activeSection) {
      case 'dashboard':
        return <BackupMonitoring />; // Render BackupMonitoring when "Dashboard" is active
      case 'backup':
        return (
         
        <div className="p-6 space-y-6">
           {/* Backup Configuration Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
               {/* Backup Scope */} 
                            <Card>
                              <CardHeader>
                                <CardTitle>
                                  <Database className="mr-2 text-red-500" />
                                  Backup Scope
                                </CardTitle>
                              </CardHeader>
                              <CardContent className="space-y-4">
                                <div className="grid grid-cols-2 gap-4">
                                {['Full Backup', 'Incremental', 'Differential', 'Synthetic Full'].map(type => (
                                      <label key={type} className="flex items-center space-x-3 p-3 bg-gray-700/50 rounded cursor-pointer hover:bg-gray-700">
                                          <input
                                              type="radio"
                                              name="backupScope"
                                              value={type.toLowerCase()}
                                              checked={backupConfig.backupScope === type.toLowerCase()} // Use backupConfig here
                                              onChange={e => setBackupConfig({ ...backupConfig, backupScope: e.target.value })} // Adjusted to backupConfig
                                              className="text-blue-500 focus:ring-blue-500"
                                          />
                                          <span>{type}</span>
                                      </label>           
                                  ))}
                                </div>
                              </CardContent>
                            </Card>           
     
               

               {/* System Selection */}
               <Card>
                <CardHeader>
                  <CardTitle>
                    <Server className="mr-2 text-blue-500" />
                    System Selection
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div className="flex justify-between">
                    <h4 className="text-sm font-medium text-gray-300">Available Systems</h4>
                    <Button variant="secondary" icon={Plus} size="sm">
                      Add New System
                    </Button>
                  </div>
                  <div className="overflow-y-auto" style={{ maxHeight: '200px' }}> {/* Adjust maxHeight as needed */}
                    <div className="space-y-2">
                      {availableSystems.map(system => (
                        <div key={system.id} className="flex items-center justify-between p-3 bg-gray-700/50 rounded">
                          <input
                            type="radio"
                            name="availableSystems"
                            value={system.id}
                            checked={config.systems.includes(system.id)}
                            onChange={() => {
                              setConfig({ ...config, systems: [system.id] });
                            }}
                          />
                          <label className="text-sm text-gray-300">{system.name}</label>
                          <span className="text-sm text-gray-400">{system.type}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </CardContent>

            </Card>

             {/* Source & Destination */}
             <Card>
                  <CardHeader>
                    <CardTitle>
                      <HardDrive size={20} className="mr-2" />
                      Source & Destination
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    <div>
                      <label className="block mb-2">Source</label>
                      <div className="flex space-x-2">
                      <Input
                          options={sourceLocalStorageOptions}
                          value={selectedSourceStorage ? selectedSourceStorage.name : ''} // Set the name if selected
                          onChange={(e) => {
                            console.log("Change Event Fired:", e.target.value); // Log the value when changed
                            const selectedOption = sourceLocalStorageOptions.find(option => option.name === e.target.value);
                            console.log("Selected Option:", selectedOption); // Log the selected option
                            if (selectedOption) {
                              handleSrcDiskChange(selectedOption);
                            }
                          }}
                          placeholder="Select source location"
                         
                        />
                      <Button variant="primary" onClick={() => openSourceModal()} disabled={!selectedSourceStorage}>
                        Browse
                      </Button>
                      </div>
                    </div>
                    <div>
                      <label className="block mb-2">Destination</label>
                      <div className="flex space-x-2">
                        <Input
                          options={destinationLocalStorageOptions}
                          value={selectedDestinationStorage ? selectedDestinationStorage.name : ''}
                          onChange={(e) => {
                            const selectedOption = destinationLocalStorageOptions.find(option => option.name === e.target.value);
                            if (selectedOption) handleDstDiskChange(selectedOption);
                          }}                   
                          
                          placeholder="Select destination location"
                          disabled={!!destinationLocalStorageOptions.length}
                        />
                        <Button variant="primary" onClick={() => openDestinationModal()} disabled={!!destinationLocalStorageOptions.length}>
                          <Cloud size={20} />
                        </Button>
                      </div>
                    </div>
                  </CardContent>
                </Card>



              {/* Schedule */}
              <Card>
                <CardHeader>
                  <CardTitle>
                    <Clock size={20} className="mr-2" />
                    Schedule
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-4">
                    <Select
                      value={backupConfig.frequency}
                      onChange={e => setBackupConfig({...backupConfig, frequency: e.target.value})}
                      options={[
                        { value: 'hourly', label: 'Hourly' },
                        { value: 'daily', label: 'Daily' },
                        { value: 'weekly', label: 'Weekly' },
                        { value: 'monthly', label: 'Monthly' },
                        { value: 'custom', label: 'Custom' },
                        { value: '', label: 'None' }
                      ]}
                    />
                    
                    {backupConfig.frequency === 'custom' && (
                      <div className="space-y-2">
                        <Input
                          type="time"
                          value={backupConfig.customSchedule.time}
                          onChange={e => setBackupConfig({
                            ...backupConfig,
                            customSchedule: {...backupConfig.customSchedule, time: e.target.value}
                          })}
                        />
                        <div className="grid grid-cols-7 gap-2">
                          {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
                            <Button
                              key={day}
                              variant={backupConfig.customSchedule.days.includes(day) ? 'primary' : 'secondary'}
                              onClick={() => {
                                const days = backupConfig.customSchedule.days.includes(day)
                                  ? backupConfig.customSchedule.days.filter(d => d !== day)
                                  : [...backupConfig.customSchedule.days, day];
                                setBackupConfig({
                                  ...backupConfig,
                                  customSchedule: {...backupConfig.customSchedule, days}
                                });
                              }}
                              className="p-2"
                            >
                              {day}
                            </Button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </CardContent>
              </Card>
            
              <Card>
                <CardHeader>
                  <CardTitle>
                    <Archive className="mr-2 text-yellow-500" />
                    Retention Policy
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">

                  {/* Retention Type Selector */}
                  <label className="block text-sm text-gray-300">Retention Type</label>
                  <Select
                    value={config.retention.type}
                    options={[
                      //{ value: 'automatic', label: 'Automatic' },
                      { value: 'manual', label: 'Manual' }
                    ]}
                    onChange={handleRetentionTypeChange}
                  />

                  {/* Keep Versions Input */}
                  {config.retention.type === 'automatic' && (
                    <div className="flex flex-col space-y-2">
                      <label className="block text-sm text-gray-300">Keep Versions</label>
                      <Input
                        type="number"
                        value={config.retention.versions}
                        min="1"
                        max="100"
                        onChange={handleVersionsChange}
                      />                     
                        <small className="text-xs text-gray-500">
                          If set to "3," the system will keep the latest 3 successful backups and automatically delete older ones.
                        </small>                      
                    </div>
                  )}

                  {/* Delete After Input */}
                  {config.retention.type === 'automatic' && (
                    <div className="flex flex-col space-y-2">
                      <label className="block text-sm text-gray-300">Delete After (days)</label>
                      <Input
                        type="number"
                        value={config.retention.deleteAfter}
                        min="1"
                        onChange={handleDeleteAfterChange}
                      />
                    </div>
                  )}

                  {/* Compression Checkbox */}
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      checked={config.compress} 
                      onChange={() => handleCompressionChange(!config.compress)}
                      className="mr-2"
                    />
                    <label className="text-sm text-gray-300">Enable Compression</label>
                  </div>
                </CardContent>
              </Card>

            {/* Data Selection */}
            <Card>
              <CardHeader>
                <CardTitle>
                  <Filter className="mr-2 text-indigo-500" />
                  Data Selection
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="space-y-2">
                  <div className="flex flex-col space-y-2">
                    <label className="block text-sm text-gray-300">Include Patterns</label>
                    <Input
                      placeholder="e.g., *.txt, /data/*"
                      value={includePatterns.join(', ')} // Convert array to string
                      onChange={handleIncludePatternsChange} // Update state on change
                    />
                  </div>
                  <div className="flex flex-col space-y-2">
                    <label className="block text-sm text-gray-300">Exclude Patterns</label>
                    <Input
                      placeholder="e.g., *.tmp, /temp/*"
                      value={excludePatterns.join(', ')} // Convert array to string
                      onChange={handleExcludePatternsChange} // Update state on change
                    />
                  </div>
                </div>

                
                <div className="space-y-2">
                  <h4 className="text-sm font-medium text-gray-300">Quick Selection</h4>
                  <div className="grid grid-cols-2 gap-2">
                    {['System Files', 'User Data', 'Applications', 'Databases'].map(item => (
                      <Checkbox 
                        key={item} 
                        label={item} 
                        checked={quickSelections[item]} // Check state
                        onChange={() => handleQuickSelectionChange(item)} // Handle change
                      />
                    ))}
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

            {/* Action Buttons */}
            <div className="flex justify-end space-x-4">
              <Button
                variant="secondary"
                onClick={() => setBackupConfig({
                  scope: '',
                  type: '',
                  frequency: 'custom',
                  customSchedule: { time: '00:00', days: [] },
                  source: '',
                  destination: '',
                  retention: '30',
                  notifications: { success: true, failure: true, warning: true }
                })}
              >
                Reset
              </Button>
              <Button
                variant="primary"
                onClick={handleBackupSubmit}
              >
                <Save size={20} className="mr-2" />
                Start Backup
              </Button>
            </div>

            
            

          </div>
        );
      // Add more cases for history, settings, etc.
      default:
        return <div>No content available</div>;
    }
  };

  return (
    <div className="flex h-screen bg-gray-900 text-gray-100">
      {/* Sidebar */}
      <div className={`bg-gray-800 ${isMenuOpen ? 'w-64' : 'w-20'} transition-all duration-300 p-4`}>
        <div className="flex items-center justify-between mb-8">
          <h1 className={`font-bold ${isMenuOpen ? 'block' : 'hidden'}`}>Backup System</h1>
          <Button variant="secondary" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <Menu size={20} />
          </Button>
        </div>

        <nav className="space-y-2">
          {[
            { icon: <Home size={20} />, label: 'Dashboard', id: 'dashboard' },
            { icon: <Settings size={20} />, label: 'Backup', id: 'backup' },
            { icon: <History size={20} />, label: 'History', id: 'history' },
            { icon: <Settings2 size={20} />, label: 'Settings', id: 'settings' },
            { icon: <HelpCircle size={20} />, label: 'Help', id: 'help' }
          ].map(item => (
            <button
              key={item.id}
              onClick={() => setActiveSection(item.id)}
              className={`flex items-center w-full p-2 rounded hover:bg-gray-700 
                ${activeSection === item.id ? 'bg-gray-700' : ''}`}
            >
              {item.icon}
              <span className={`ml-3 ${isMenuOpen ? 'block' : 'hidden'}`}>
                {item.label}
              </span>
            </button>
          ))}
        </nav>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-auto">
      <div className="bg-gray-800 border-b border-gray-700 shadow-sm">
      {/* Main Navigation Bar */}
      <div className="px-6 py-4">
        <div className="flex justify-between items-center">
          {/* Left Section - Title and Search */}
          <div className="flex-1">
            <div className="flex items-center space-x-4">
              <div>
                <h2 className="text-xl font-semibold text-gray-100">{sectionInfo.title}</h2>
                <p className="text-sm text-gray-400 mt-1 flex items-center">
                  {sectionInfo.description}
                  <span className="mx-2">•</span>
                  <Clock size={14} className="mr-1" />
                  Updated {sectionInfo.lastUpdated}
                </p>
              </div>
            </div>
          </div>

          {/* Right Section - Actions */}
          <div className="flex items-center space-x-4">
            {/* Search */}
            <div className="relative hidden md:block">
              <input
                type="text"
                placeholder="Quick search..."
                className="w-48 bg-gray-700 border border-gray-600 rounded-md pl-10 pr-4 py-2 text-sm text-gray-300 placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              />
              <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
            </div>

           

            {/* Refresh Button */}
            <button className="p-2 hover:bg-gray-700 rounded-md text-gray-400 hover:text-gray-300 transition-colors duration-200">
              <RefreshCw size={20} />
            </button>

            {/* Download Button */}
            <button className="p-2 hover:bg-gray-700 rounded-md text-gray-400 hover:text-gray-300 transition-colors duration-200">
              <Download size={20} />
            </button>

            {/* Notifications */}
            <div className="relative">
              <button
                onClick={() => setShowNotifications(!showNotifications)}
                className="p-2 hover:bg-gray-700 rounded-md text-gray-400 hover:text-gray-300 transition-colors duration-200 relative"
              >
                <Bell size={20} />
                <span className="absolute -top-1 -right-1 h-4 w-4 bg-blue-500 rounded-full text-xs flex items-center justify-center text-white">
                  3
                </span>
              </button>

              {showNotifications && (
                <div className="absolute right-0 mt-2 w-80 bg-gray-700 rounded-md shadow-lg py-1 z-10 border border-gray-600">
                  <div className="px-4 py-2 border-b border-gray-600 flex justify-between items-center">
                    <span className="font-medium text-gray-200">Notifications</span>
                    <button className="text-xs text-blue-400 hover:text-blue-300">
                      Mark all as read
                    </button>
                  </div>
                  {notifications.map(notification => (
                    <div key={notification.id} className="px-4 py-3 hover:bg-gray-600 cursor-pointer">
                      <div className="flex items-start">
                        <CheckCircle2 className="w-4 h-4 text-green-400 mt-1 mr-2" />
                        <div>
                          <p className="text-sm text-gray-200">{notification.message}</p>
                          <p className="text-xs text-gray-400 mt-1">{notification.time}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Profile Picture */}
            <div className="flex items-center space-x-3">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBlYJfFRvdZG0LNuiRs6l1PNx1bIfZkqZIsQ&s"
                alt="Profile"
                className="h-8 w-8 rounded-full border-2 border-gray-600"
              />
              <button className="p-1 hover:bg-gray-700 rounded-md text-gray-400 hover:text-gray-300">
                <MoreHorizontal size={20} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

        {/* Main Content Area */}
        {renderActiveContent()}
      </div>
      
       {/* Render the BackupConfigModal if isBackupSummaryVisible is true */}
       {/*{isBackupSummaryVisible && (
        <BackupConfigModal 
          isOpen={isBackupSummaryVisible} 
          onClose={() => setBackupSummaryVisible(false)} 
          config={currentBackupConfig} 
          onConfirm={() => {
            console.log('Confirmed:', currentBackupConfig);
            setBackupSummaryVisible(false); // Close the modal after confirmation
          }} 
        />
      )}*/}
      {isBackupSummaryVisible && (
          <BackupConfigModal 
            isOpen={isBackupSummaryVisible} 
            onClose={() => setBackupSummaryVisible(false)} 
            config={currentBackupConfig} 
            onConfirm={handleBackupConfirmation} // Updated to use the new function
          />
      )}

      <BackupAnimationSystem
        isBackupPopupOpen={isBackupPopupOpen}
        setIsBackupPopupOpen={setIsBackupPopupOpen}
      />

      <EnhancedModal 
        isOpen={isModalOpen}
        onModalClose={setModalOpen} // Pass the function directly
        title={modalTitle}
        variant={modalVariant} 
        message={modalMessage}
        validationErrors={validationErrors}
        showCloseButton={true}
      />
 
     
      {showSourceModal && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-auto">
        <div className="bg-gray-800 rounded-lg w-full max-w-4xl mx-4 max-h-[80vh] overflow-y-auto">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b">
            <h2 className="text-xl font-semibold">Select Source</h2>
            <button 
              onClick={() => setShowSourceModal(false)}
              className="p-2 hover:bg-gray-100 rounded-full"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6">
            <SourceConfiguration 
              srcLocalStorage={sourceLocalStorageOptions}
              srcStorageTypes={sourceStorageTypes}
              srcStorage={selectedSourceStorage}
              setSrcStorage={setSelectedSourceStorage}
              srcFolderContents={sourceFolderContents}
              srcDiskMessage={selectedSourceDiskMessage}
              handleSrcDiskClick={handleSourceDiskClick}
              handleSrcStorageSelect={handleSourceStorageSelect}
              srcSelectedItems={selectedItems}           
              handleSrcItemClick={handleSourceItemClick}
              srcProvider={selectedSourceProvider}
              setSrcProvider={setSelectedSourceProvider}
              srcFormData={sourceFormData}
              setSrcFormData={setSourceFormData}
              handleSrcInputChange={handleSrcInputChange}
              handleSrcApply={handleSrcApply}
              srcFieldErrors={sourceFieldErrors}
            />
          </div>
        </div>
      </div>
    )}

    {showDestinationModal && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-auto">
        <div className="bg-gray-800 rounded-lg w-full max-w-4xl mx-4 max-h-[80vh] overflow-y-auto">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b">
            <h2 className="text-xl font-semibold">Configure Destination</h2>
            <button 
              onClick={() => setShowDestinationModal(false)}
              className="p-2 hover:bg-gray-100 rounded-full"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6">
            <DestinationConfiguration
              destLocalStorageOptions={destinationLocalStorageOptions}
              destStorageTypes={destinationStorageTypes}
              destStorage={selectedDestinationStorage}
              setDestStorage={setSelectedDestinationStorage}
              destFolderContents={destinationFolderContents}
              destDiskMessage={selectedDestinationDiskMessage}
              handleDestDiskClick={handleDestinationDiskClick}
              handleDestStorageSelect={handleDestinationStorageSelect}
              destSelectedItems={selectedItems}
              handleDestItemClick={handleDestinationItemClick}
              destProvider={selectedDestinationProvider}
              setDestProvider={setSelectedDestinationProvider}
              destFormData={destinationFormData}
              setDestFormData={setDestinationFormData}
              handleDestInputChange={handleDestInputChange}
              handleDestApply={handleDestinationApply}
              destFieldErrors={destinationFieldErrors}
            />
          </div>
        </div>
      </div>
    )}

   
    </div>
  );
};

export default BackupSystem;